import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	no: {
		id: 'ui.contentOverview.tableFilter.no',
	},
	yes: {
		id: 'ui.contentOverview.tableFilter.yes',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: boolean;
	}>;
	falseColor?: string;
	height?: number;
	name: string;
	percentageFactor?: number;
};

const BooleanChart: React.FC<Props> = (props) => {
	const {
		data,
		falseColor = '#FF5959',
		height,
		name,
		percentageFactor = 100,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: true,
			label: intl.formatMessage(messages.yes),
			color: '#42CC67',
		},
		{
			value: false,
			label: intl.formatMessage(messages.no),
			color: falseColor,
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			height={height}
			name={name}
			percentageFactor={percentageFactor}
		/>
	);
};



export default React.memo(BooleanChart);
